<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0"
  >
    <div class="rounded-t bg-blue-500 mb-0 px-6 py-6">
      <div class="text-center flex justify-between items-center">
        <div class="flex flex-col items-start">
          <h6 class="text-white text-xl font-bold">{{title}}</h6>
          <p class="mt-2 text-xs text-white" v-if="subtitle!==''">{{subtitle}}</p>
        </div>
        <div class="flex flex-col md:flex-row">
          <slot name="button"></slot>
        </div>
      </div>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-10">
      <slot name="body"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/Card.vue